import translations from '../translation.json';
export const Constants = {...translations}